import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {AnalysisTab, CoverageAnalysisView} from '../rfi-coverage-analysis-dialog.types';
import {CoverageKpiCardComponent} from '../coverage-kpi-card/coverage-kpi-card.component';
import {CoverageSectionComponent} from '../coverage-section/coverage-section.component';
import {CoverageTabLinkComponent} from '../coverage-tab-link/coverage-tab-link.component';
import {RfiCoverageBarComponent} from '../../rfi-coverage-bar/rfi-coverage-bar.component';

@Component({
  selector: 'app-coverage-overview-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AppNumberPipe,
    TranslocoPipe,
    Button,
    CoverageKpiCardComponent,
    CoverageSectionComponent,
    CoverageTabLinkComponent,
    RfiCoverageBarComponent,
  ],
  templateUrl: './coverage-overview-tab.component.html',
})
export class CoverageOverviewTabComponent {
  readonly view = input.required<CoverageAnalysisView>();

  readonly tabRequested = output<AnalysisTab>();
}
